jQuery(document).ready(function ($) {
    var $blocMachines = $('.bloc_machines');
    if (!$blocMachines.length) return;

    var $sections = $blocMachines.find('.liste_globale');
    var $backgrounds = $blocMachines.find('.background');
    var ticking = false;

    function updateActiveBackground() {
        var viewportCenter = window.scrollY + (window.innerHeight / 2);
        var current = null;
        var closestDistance = Infinity;

        $sections.each(function () {
            var rect = this.getBoundingClientRect();
            var top = rect.top + window.scrollY;
            var bottom = top + rect.height;

            if (viewportCenter >= top && viewportCenter <= bottom) {
                current = this;
            }

            var mid = (top + bottom) / 2;
            var distance = Math.abs(viewportCenter - mid);
            if (!current && distance < closestDistance) {
                closestDistance = distance;
            }
        });

        if (!current) {
            closestDistance = Infinity;
            $sections.each(function () {
                var rect = this.getBoundingClientRect();
                var top = rect.top + window.scrollY;
                var bottom = top + rect.height;
                var mid = (top + bottom) / 2;
                var distance = Math.abs(viewportCenter - mid);
                if (distance < closestDistance) {
                    closestDistance = distance;
                    current = this;
                }
            });
        }

        if (current) {
            var cible = $(current).data('cible');
            $backgrounds.removeClass('active');
            $backgrounds.filter('[data-cible="' + cible + '"]').addClass('active');
        }

        ticking = false;
    }

    function onScroll() {
        if (!ticking) {
            window.requestAnimationFrame(updateActiveBackground);
            ticking = true;
        }
    }

    updateActiveBackground();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
});